import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  ChangeDetectionStrategy,
  SimpleChanges,
  inject
} from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AsyncPipe, NgClass } from '@angular/common';
import { ClassificationResult } from '@jump-tech-frontend/domain';
import { MetadataPanelVm } from './metadata-panel.model';
import { MetadataPanelPresenter } from './metadata-panel.presenter';
import { JuiAlertBlock, JuiButton } from '@jump-tech-frontend/core-components-angular';
import { I18nKeys } from '@jump-tech-frontend/app-config';

@Component({
  selector: 'crds-metadata-panel',
  standalone: true,
  templateUrl: './metadata-panel.component.html',
  styleUrls: ['./metadata-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, NgClass, JuiAlertBlock, JuiButton],
  providers: [MetadataPanelPresenter]
})
export class MetadataPanelComponent implements OnChanges {
  private presenter = inject(MetadataPanelPresenter);

  @Input() classificationResult: ClassificationResult | null = null;
  @Input() showBoundingBoxes = true;
  @Input() i18ns: I18nKeys;
  @Output() boundingBoxToggle = new EventEmitter<boolean>();

  vm$: BehaviorSubject<MetadataPanelVm> = new BehaviorSubject<MetadataPanelVm>(null);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['i18ns']) {
      this.presenter.setI18ns(this.i18ns);
    }
    this.presenter.load(this.vm$, this.classificationResult);
  }

  onToggleBoundingBoxes(): void {
    this.boundingBoxToggle.emit(!this.showBoundingBoxes);
  }
}
